import { render, staticRenderFns } from "./admin_add.vue?vue&type=template&id=d57685e4&scoped=true&"
import script from "./admin_add.vue?vue&type=script&lang=js&"
export * from "./admin_add.vue?vue&type=script&lang=js&"
import style0 from "./admin_add.vue?vue&type=style&index=0&id=d57685e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57685e4",
  null
  
)

export default component.exports